import { ChartProps } from 'react-chartjs-2';
import { sum } from 'lodash';

import theme from '~config/theme';
import { createArrayFromNumber } from '~utils/commons';

type PunctualityOfVisitsChartProps = ChartProps<'line', number[], number>;

export const getPunctualityOfVisitsChartProps = ({
  visitTotalCount,
  visitedCompletedOnTimeCount,
}: {
  visitedCompletedOnTimeCount: number[];
  visitTotalCount: number[];
}): PunctualityOfVisitsChartProps => {
  const labels = createArrayFromNumber(visitTotalCount.length, true);

  const data: PunctualityOfVisitsChartProps['data'] = {
    labels,
    datasets: [
      {
        label: `Total de visitas (${sum(visitTotalCount)})`,
        data: visitTotalCount,
        borderColor: theme.palette.tertiary.main,
        backgroundColor: theme.palette.tertiary.light,
        fill: 1,
      },
      {
        label: `Visitas dentro de ventana horaria (${sum(
          visitedCompletedOnTimeCount,
        )})`,
        data: visitedCompletedOnTimeCount,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light,
        fill: true,
      },
    ],
  };

  const options: PunctualityOfVisitsChartProps['options'] = {
    responsive: true,
    plugins: {
      filler: {
        drawTime: 'beforeDatasetsDraw',
        propagate: false,
      },
      legend: {
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          usePointStyle: true,
        },
      },
    },
    interaction: {
      intersect: false,
    },
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: { stepSize: 5 },
        beginAtZero: true,
      },
    },
  };

  return { data, options, type: 'line' };
};
